import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import CourseStore from '../../../../../../../../Store/CourseStore'
import { RegistrationModalEl } from '../elements'
import {
  H3,
  H4,
  S1,
  Text,
} from '../../../../../../../../../../Styles/typography'
import { useToggle } from '../../../../../../../../../../Helpers/CustomHooks/useToggle'
import Button from '../../../../../../../../../../Components/Buttons/Button'
import RecordedCourseDashboardStore from '../../../../../stores/RecordedCourseDashboardStore'
import withStore from '../../../../../../../../../../Components/Unstated/withStore'

const RegistrationModal = ({
  courseStore: {
    state: {
      hasCertification = false,
      certificationFeePremium = 50,
      name,
      discount = 0,
      stdFee,
      teacher: { name: teacherName = 'artist' } = {},
    } = {},
    enrollRecorded,
  },
}) => {
  const history = useHistory()
  const [disabled, toggle] = useToggle(false)
  const {
    activeSubscription = [],
    toggleRegistrationModal,
  } = RecordedCourseDashboardStore.useContainer()

  useEffect(() => {
    if (name && !hasCertification) {
      ;(async () => {
        toggle(true)
        const success = await enrollRecorded('STANDARD')
        if (success) {
          history.push(`/billing/payment/${success.billId}`)
        }
        toggle(false)
      })()
    }
  }, [
    enrollRecorded,
    hasCertification,
    history,
    name,
    toggle,
    toggleRegistrationModal,
  ])

  const subscriptionDiscount = (() =>
    activeSubscription[0]?.discounts?.recordedCourse || 0)()

  const finalDiscount = (() => {
    return discount + ((100 - discount) * subscriptionDiscount) / 100
  })()

  return !hasCertification ? null : (
    <RegistrationModalEl onClick={() => toggleRegistrationModal(false)}>
      <div onClick={(e) => e.stopPropagation()}>
        <H3>{name}</H3>
        <Text>Pick a type of registration</Text>
        <div className='options'>
          <div className='type'>
            <H4>Certification</H4>
            <div className='full-height'>
              <div className='fee'>
                {Boolean(finalDiscount) && (
                  <S1 className='original'>
                    <span className='originalAmount'>
                      {stdFee?.currency} {stdFee?.amount * (1 + 50 / 100)}
                    </span>
                    <span className='percentOff'>({finalDiscount}% off)</span>
                  </S1>
                )}
                <div className='final'>
                  {Boolean(finalDiscount) ? (
                    <H3 bold>
                      {stdFee?.currency}{' '}
                      {Math.round(
                        stdFee.amount *
                          (1 + certificationFeePremium / 100) *
                          (1 - finalDiscount / 100) *
                          100,
                      ) / 100}
                    </H3>
                  ) : (
                    <H3 bold>
                      {stdFee?.currency}{' '}
                      {stdFee?.amount * (1 + certificationFeePremium / 100)}
                    </H3>
                  )}
                </div>
              </div>
              <p>
                Certification course ensures that along with the doing the
                course at your own pace, you also have a chance to interact with
                the artist/teacher to ask any questions, clarify any doubts,
                submit the assignments and receive feedback directly from the
                teachers. You also receive a certificate signed by the
                artist/teacher.
              </p>
              <ul>
                <li>Lifetime access to the course material</li>
                <li>Do at your own pace</li>
                <li>Submit assignments</li>
                <li>Get feedback and reviews from {teacherName}</li>
                <li>
                  Attend live Q&A session with {teacherName}, upto one year.
                </li>
                <li>Receive a certificate on completion</li>
              </ul>
            </div>

            <Button
              onClick={async () => {
                toggle(true)
                const success = await enrollRecorded('CERTIFICATION')
                if (success) {
                  history.push(`/billing/payment/${success.billId}`)
                }
                toggle(false)
              }}
              disabled={disabled}
            >
              Buy Certification
            </Button>
          </div>
          <div className='type'>
            <H4>Standard</H4>
            <div className='full-height'>
              <div className='fee'>
                {Boolean(finalDiscount) && (
                  <S1 className='original'>
                    <span className='originalAmount'>
                      {stdFee?.currency} {stdFee?.amount}
                    </span>
                    <span className='percentOff'>({finalDiscount}% off)</span>
                  </S1>
                )}
                <div className='final'>
                  {Boolean(finalDiscount) ? (
                    <H3 bold>
                      {stdFee?.currency}{' '}
                      {Math.round(
                        stdFee.amount * (1 - finalDiscount / 100) * 100,
                      ) / 100}
                    </H3>
                  ) : (
                    <H3 bold>
                      {stdFee?.currency} {stdFee?.amount}
                    </H3>
                  )}
                </div>
              </div>
              <p>
                You have unlimited access to the course, anytime, anywhere and
                you do it at your own pace, and self-assess.
              </p>
              <ul>
                <li>Lifetime access to the course material</li>
                <li>Do at your own pace</li>
              </ul>
            </div>

            <Button
              onClick={async () => {
                toggle(true)
                const success = await enrollRecorded()
                if (success) {
                  history.push(`/billing/payment/${success.billId}`)
                }
                toggle(false)
              }}
              disabled={disabled}
            >
              Buy Standard
            </Button>
          </div>
        </div>
      </div>
    </RegistrationModalEl>
  )
}

export default withStore([CourseStore])(RegistrationModal)
